import { AppLookupResponse } from './../models/app-lookup-response';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppSharedService {
  baseUrl: string = `${environment.baseApiUrl}/AppLookup`;

  constructor(private httpClient: HttpClient) { }

  getLanguages = ():Observable<AppLookupResponse[]> => {
    return this.httpClient.get<AppLookupResponse[]>(`${this.baseUrl}/languages`);
  }

  submitContactUsDetails = (request: any): Observable<boolean> => {
    return this.httpClient.post<boolean>(`${this.baseUrl}/contact-us`, request);
  }
}